import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import AdfScannerOutlinedIcon from '@mui/icons-material/AdfScannerOutlined';
import AnalyticsOutlinedIcon from '@mui/icons-material/AnalyticsOutlined';
import ApartmentRoundedIcon from '@mui/icons-material/ApartmentRounded';
import ArchitectureOutlinedIcon from '@mui/icons-material/ArchitectureOutlined';
import BiotechOutlinedIcon from '@mui/icons-material/BiotechOutlined';
import BoltRoundedIcon from '@mui/icons-material/BoltRounded';
import BrushOutlinedIcon from '@mui/icons-material/BrushOutlined';
import BubbleChartOutlinedIcon from '@mui/icons-material/BubbleChartOutlined';
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import ConstructionRoundedIcon from '@mui/icons-material/ConstructionRounded';
import EngineeringOutlinedIcon from '@mui/icons-material/EngineeringOutlined';
import ExploreOutlinedIcon from '@mui/icons-material/ExploreOutlined';
import ForestOutlinedIcon from '@mui/icons-material/ForestOutlined';
import GavelRoundedIcon from '@mui/icons-material/GavelRounded';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import HailRoundedIcon from '@mui/icons-material/HailRounded';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import HeadsetMicOutlinedIcon from '@mui/icons-material/HeadsetMicOutlined';
import HomeWorkOutlinedIcon from '@mui/icons-material/HomeWorkOutlined';
import IntegrationInstructionsOutlinedIcon from '@mui/icons-material/IntegrationInstructionsOutlined';
import LandscapeOutlinedIcon from '@mui/icons-material/LandscapeOutlined';
import LocalLibraryOutlinedIcon from '@mui/icons-material/LocalLibraryOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import MedicalServicesOutlinedIcon from '@mui/icons-material/MedicalServicesOutlined';
import MenuBookIconIcon from '@mui/icons-material/MenuBook';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import PrecisionManufacturingOutlinedIcon from '@mui/icons-material/PrecisionManufacturingOutlined';
import SchemaOutlinedIcon from '@mui/icons-material/SchemaOutlined';
import SecurityOutlinedIcon from '@mui/icons-material/SecurityOutlined';
import SettingsAccessibilityOutlinedIcon from '@mui/icons-material/SettingsAccessibilityOutlined';
import SettingsApplicationsOutlinedIcon from '@mui/icons-material/SettingsApplicationsOutlined';
import SignpostOutlinedIcon from '@mui/icons-material/SignpostOutlined';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import SupervisedUserCircleOutlinedIcon from '@mui/icons-material/SupervisedUserCircleOutlined';
import TranslateIcon from '@mui/icons-material/Translate';
import WorkspacePremiumOutlinedIcon from '@mui/icons-material/WorkspacePremiumOutlined';
import {
  CardActionArea,
  CardContent,
  Link,
  Stack,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router';
import type { KnowledgeArea } from '@/models/bootstrap/taxonomy';

const Icon = ({ identifier }: { identifier: number }) => {
  const iconMap = {
    1: AdfScannerOutlinedIcon,
    2: ForestOutlinedIcon,
    3: AnalyticsOutlinedIcon,
    4: ArchitectureOutlinedIcon,
    5: BusinessCenterOutlinedIcon,
    6: HeadsetMicOutlinedIcon,
    7: SignpostOutlinedIcon,
    8: LocalLibraryOutlinedIcon,
    9: MenuBookIconIcon,
    10: BoltRoundedIcon,
    11: EngineeringOutlinedIcon,
    12: LandscapeOutlinedIcon,
    13: AccountBalanceOutlinedIcon,
    14: MedicalServicesOutlinedIcon,
    15: ApartmentRoundedIcon,
    16: GroupsOutlinedIcon,
    17: IntegrationInstructionsOutlinedIcon,
    18: GavelRoundedIcon,
    19: ConstructionRoundedIcon,
    20: PrecisionManufacturingOutlinedIcon,
    21: HailRoundedIcon,
    22: CampaignOutlinedIcon,
    23: BubbleChartOutlinedIcon,
    24: SettingsAccessibilityOutlinedIcon,
    25: SchemaOutlinedIcon,
    26: HomeWorkOutlinedIcon,
    27: SecurityOutlinedIcon,
    28: StorefrontOutlinedIcon,
    29: BiotechOutlinedIcon,
    30: HandshakeOutlinedIcon,
    31: LocalShippingOutlinedIcon,
    32: SupervisedUserCircleOutlinedIcon,
    33: TranslateIcon,
    34: CategoryOutlinedIcon,
    35: WorkspacePremiumOutlinedIcon,
    75: BrushOutlinedIcon,
    76: ExploreOutlinedIcon,
    77: PeopleAltOutlinedIcon,
    78: SettingsApplicationsOutlinedIcon,
  };

  const IconComponent = iconMap[identifier as keyof typeof iconMap];

  return IconComponent && <IconComponent sx={{ color: 'primary.dark' }} />;
};

interface KnowledgeAreaCardProps {
  data: KnowledgeArea & { link: string };
}

export const KnowledgeAreaCard = ({ data }: KnowledgeAreaCardProps) => {
  const navigate = useNavigate();

  return (
    <CardActionArea
      component={Link}
      href={data.link}
      onClick={(e) => {
        e.preventDefault();
        navigate(data.link);
      }}
      sx={({ shape, palette }) => ({
        display: 'flex',
        height: 115,
        justifyContent: 'center',
        p: 2,
        borderRadius: `${shape.borderRadius}px`,
        backgroundColor: palette.background.paper,
      })}
    >
      <CardContent>
        <Stack spacing={1} alignItems="center" justifyContent="center">
          <Icon identifier={data.id} />
          <Typography variant="body2" textAlign="center">
            {data.description_pt_br}
          </Typography>
        </Stack>
      </CardContent>
    </CardActionArea>
  );
};
